import { Auth } from "aws-amplify";

const getJwt = async () => {
  const user = await Auth.currentAuthenticatedUser();

  return user.signInUserSession.idToken.jwtToken;
};

export default getJwt;
